import { getRequest, postRequest } from ".";
import apiEndpoints from "./apiEndpoints";

export const attemptUploadImages = (payload) =>
  postRequest(apiEndpoints.images.postImages, payload);

export const attemptFetchImages = (payload, option) =>
  getRequest(apiEndpoints.images.getImages, payload, option);
